import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
} from '@chakra-ui/react';
import { ErrorMessage } from '@hookform/error-message';
import type { SnapSiteConfigEditFormDataUnvalidated } from '@snap-types/models/snap-site-config';
import type { FieldPathFn } from '@ui/components/form';
import { get, useFormContext } from 'react-hook-form';

export function RAFFixedMarketForm({
  fieldPath,
}: {
  fieldPath: FieldPathFn<SnapSiteConfigEditFormDataUnvalidated>;
}) {
  const form = useFormContext();

  const defaultDaysFieldPath = fieldPath('defaultDays');
  const nasPartDaysFieldPath = fieldPath('nasPartDays');

  const defaultDaysFieldError = get(
    form.formState.errors,
    defaultDaysFieldPath,
  );

  const nasPartDaysFieldError = get(
    form.formState.errors,
    nasPartDaysFieldPath,
  );

  return (
    <>
      <FormControl isInvalid={!!defaultDaysFieldError} isRequired>
        <FormLabel htmlFor={defaultDaysFieldPath}>Default Days:</FormLabel>

        <Input
          {...form.register(defaultDaysFieldPath)}
          id={defaultDaysFieldPath}
          type="number"
          inputMode="numeric"
          min={0}
        />

        <ErrorMessage
          name={defaultDaysFieldPath}
          render={({ message }) => (
            <FormErrorMessage>{message}</FormErrorMessage>
          )}
        />
      </FormControl>

      <FormControl isInvalid={!!nasPartDaysFieldError} isRequired>
        <FormLabel htmlFor={nasPartDaysFieldPath}>NAS Part Days:</FormLabel>

        <Input
          {...form.register(nasPartDaysFieldPath)}
          id={nasPartDaysFieldPath}
          type="number"
          inputMode="numeric"
          min={0}
        />

        <ErrorMessage
          name={nasPartDaysFieldPath}
          render={({ message }) => (
            <FormErrorMessage>{message}</FormErrorMessage>
          )}
        />
      </FormControl>
    </>
  );
}
